import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.subnets');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-subnets',
template: templateSource || '',
    styles: [``],
})
export class PageKieraSubnetsComponent implements OnInit {
    public list: any[] = [];
    public total: number = 0;
    public search: any = { text: "", page: 1, dump: 20 };

    // Edit modal
    public showEditModal: boolean = false;
    public isAddingSubnet: boolean = false;
    public editItem: any = null;
    public savingSubnet: boolean = false;

    // PE list for select
    public peList: any[] = [];

    // Scan modal
    public showScanModal: boolean = false;
    public scannedInterfaces: any[] = [];
    public scanning: boolean = false;
    public scanError: string = '';

    // DHCP config modal
    public showDhcpModal: boolean = false;
    public dhcpConfig: string = '';
    public dhcpConfigPath: string = '/etc/dhcp/dhcpd.conf';
    public generatingDhcp: boolean = false;

    // NFS exports modal
    public showNfsModal: boolean = false;
    public nfsExports: string = '';
    public nfsExportsPath: string = '/etc/exports.d/wiz-kiera.exports';
    public generatingNfs: boolean = false;

    // PXE status modal
    public showPxeModal: boolean = false;
    public pxeStatus: any = null;
    public loadingPxeStatus: boolean = false;

    // Protocol labels
    public protocolOptions = [
        { value: 0, label: 'HTTP' },
        { value: 1, label: 'NFS over RDMA' },
        { value: 2, label: 'NFS' },
    ];

    public interfaceTypeOptions = [
        { value: 'general', label: 'General' },
        { value: 'infiniband', label: 'InfiniBand' },
    ];

    // Sorting
    public sortField: string = 'name';
    public sortDir: string = 'asc';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadPeList();
        await this.load();
        await this.service.render();
    }

    public async loadPeList() {
        const { code, data } = await wiz.call("pe_list");
        if (code === 200) {
            this.peList = data.rows || [];
        }
    }

    public async load(page: number = 1) {
        this.search.page = page;
        const { code, data } = await wiz.call("search", this.search);
        if (code === 200) {
            this.list = data.rows;
            this.total = data.total;
            this.sortList();
        }
        await this.service.render();
    }

    // ===== Scan =====
    public async openScanModal() {
        if (this.scanning) return;

        this.showScanModal = true;
        this.scanning = true;
        this.scanError = '';
        this.scannedInterfaces = [];
        await this.service.render();

        try {
            const { code, data } = await wiz.call("scan_interfaces");
            if (code === 200) {
                this.scannedInterfaces = Array.isArray(data?.interfaces) ? data.interfaces : [];
            } else {
                this.scanError = code === 401 ? 'Session expired. Please sign in again.' : (data?.message || 'Scan failed');
                alert(this.scanError);
            }
        } catch (e) {
            this.scanError = 'Scan failed';
            alert(this.scanError);
        } finally {
            this.scanning = false;
            await this.service.render();
        }
    }

    public async registerInterface(iface: any) {
        if (!iface || iface.registering || iface.registered || this.isAlreadyRegistered(iface)) return;

        iface.registering = true;
        await this.service.render();

        const newSubnet: any = {
            name: iface.ifname,
            cidr: iface.network + '/' + iface.prefixlen,
            ipv4_address: iface.ip || '',
            gateway: iface.gateway || '',
            dns_servers: '',
            dhcp_enabled: 0,
            dhcp_start: '',
            dhcp_end: '',
            dhcp_next_server: iface.ip || '',
            create_pxe_bootloader: 1,
        };

        try {
            const { code, data } = await wiz.call("create", { data: JSON.stringify(newSubnet) });
            if (code === 200) {
                iface.registered = true;
                if (data?.pxe_generated === false && !data?.pxe_skipped) {
                    alert(data?.pxe_message || data?.message || 'Failed to generate PXE bootloader');
                }
                if (data?.dhcp_applied === false) {
                    alert(data?.message || 'Failed to regenerate DHCP configuration');
                }
                await this.load();
            } else {
                alert(data?.message || 'Failed to register');
            }
        } finally {
            iface.registering = false;
            await this.service.render();
        }
    }

    public isAlreadyRegistered(iface: any): boolean {
        return this.list.some((s: any) =>
            s.name === iface.ifname || s.cidr === (iface.network + '/' + iface.prefixlen)
        );
    }

    public macPreview(mac: any): string {
        const value = String(mac || '');
        return value.length > 6 ? value.slice(0, 6) : value;
    }

    public isMacTruncated(mac: any): boolean {
        return String(mac || '').length > 6;
    }

    // ===== DHCP Config =====
    public async openDhcpModal() {
        this.showDhcpModal = true;
        this.generatingDhcp = true;
        this.dhcpConfig = '';
        await this.service.render();

        const { code, data } = await wiz.call("generate_dhcp_config");
        this.generatingDhcp = false;
        if (code === 200) {
            this.dhcpConfig = data.config || '';
            this.dhcpConfigPath = data.config_path || this.dhcpConfigPath;
        } else {
            this.dhcpConfig = '# Error: ' + (data?.message || 'Failed to read current dhcpd.conf');
        }
        await this.service.render();
    }

    public async applyDhcpConfig() {
        if (!confirm('Save this DHCP configuration to dhcpd.conf?\nThe DHCP service state will not change. Use /kiera/logs to start or stop it.')) return;
        const { code, data } = await wiz.call("apply_dhcp_config", { config: this.dhcpConfig });
        if (code === 200) {
            const messages = Array.isArray(data?.messages) ? data.messages.join('\n') : '';
            alert(messages || 'DHCP configuration saved. Manage the service from /kiera/logs.');
            this.showDhcpModal = false;
        } else {
            alert(data?.message || 'Failed to apply DHCP config');
        }
        await this.service.render();
    }

    // ===== NFS Exports =====
    public async openNfsModal() {
        this.showNfsModal = true;
        this.generatingNfs = true;
        this.nfsExports = '';
        await this.service.render();

        const { code, data } = await wiz.call("generate_nfs_exports");
        this.generatingNfs = false;
        if (code === 200) {
            this.nfsExports = data.exports || '';
            this.nfsExportsPath = data.exports_path || this.nfsExportsPath;
        } else {
            this.nfsExports = '# Error: ' + (data?.message || 'Failed to generate');
        }
        await this.service.render();
    }

    public async applyNfsExports() {
        if (!confirm(`Apply NFS exports configuration?\nThis will update ${this.nfsExportsPath} and reload NFS.`)) return;
        const { code, data } = await wiz.call("apply_nfs_exports", { exports: this.nfsExports });
        if (code === 200) {
            this.nfsExportsPath = data.exports_path || this.nfsExportsPath;
            alert('NFS exports applied successfully.');
            this.showNfsModal = false;
        } else {
            alert(data?.message || 'Failed to apply NFS exports');
        }
        await this.service.render();
    }

    // ===== PXE Status =====
    public async openPxeModal() {
        this.showPxeModal = true;
        this.loadingPxeStatus = true;
        this.pxeStatus = null;
        await this.service.render();

        const { code, data } = await wiz.call("pxe_status");
        this.loadingPxeStatus = false;
        if (code === 200) {
            this.pxeStatus = data;
        }
        await this.service.render();
    }

    public async generatePxeBootloader(subnetId: number) {
        const ok = await this.ensurePxeBootloader(subnetId, true);
        if (ok) {
            await this.openPxeModal();
        }
        await this.service.render();
    }

    public async ensurePxeBootloader(subnetId: number, notifySuccess: boolean = false) {
        const { code, data } = await wiz.call("generate_pxe_bootloader", { id: subnetId });
        if (code === 200) {
            if (notifySuccess) {
                alert(data.message || 'PXE bootloader generated.');
            }
            return true;
        } else {
            alert(data?.message || 'Failed to generate PXE bootloader');
        }
        return false;
    }

    public async syncDhcpConfig() {
        const { code, data } = await wiz.call("regenerate_dhcp");
        if (code !== 200 || data?.dhcp_applied === false) {
            alert(data?.message || 'Failed to regenerate DHCP configuration');
            return false;
        }
        return true;
    }

    // ===== Add / Edit =====
    private buildSubnetForm(data: any = {}) {
        const dns = data.dns_servers || '';
        const dnsParts = dns.split(',').map((s: string) => s.trim());
        return {
            ...data,
            name: data.name || '',
            cidr: data.cidr || '',
            dns1: dnsParts[0] || '',
            dns2: dnsParts[1] || '',
            gateway: data.gateway || '',
            ipv4_address: data.ipv4_address || '',
            fabric: data.fabric || '',
            description: data.description || '',
            vlan_id: data.vlan_id || 0,
            managed: data.managed !== undefined ? data.managed : 1,
            dhcp_enabled: data.dhcp_enabled !== undefined ? data.dhcp_enabled : 0,
            dhcp_start: data.dhcp_start || '',
            dhcp_end: data.dhcp_end || '',
            default_lease: data.default_lease || 600,
            max_lease: data.max_lease || 7200,
            dhcp_next_server: data.dhcp_next_server || '',
            network_interface_type: data.network_interface_type || 'general',
            rootfs_transport_protocol: data.rootfs_transport_protocol !== undefined ? data.rootfs_transport_protocol : 0,
            create_pxe_bootloader: data.create_pxe_bootloader !== undefined && data.create_pxe_bootloader !== null ? data.create_pxe_bootloader : 1,
            preinstallation_environment_id: data.preinstallation_environment_id || null,
            dhcp_option_always_broadcast: data.dhcp_option_always_broadcast || 0,
            pe_kernel_option_network_config_disable: data.pe_kernel_option_network_config_disable || 0,
        };
    }

    public isOpaStaticOnly(item: any = this.editItem): boolean {
        const nicType = String(item?.network_interface_type || '').trim().toLowerCase();
        const interfaceName = String(item?.name || '').trim().toLowerCase();
        return nicType === 'infiniband' || nicType === 'ipoib' || nicType === 'opa'
            || interfaceName.startsWith('ib') || interfaceName.startsWith('opa');
    }

    public onInterfaceTypeChange(_value: any) {
        if (this.editItem && this.isOpaStaticOnly(this.editItem)) {
            this.editItem.dhcp_enabled = 0;
        }
    }

    public toggleDhcp() {
        if (!this.editItem || this.isOpaStaticOnly(this.editItem)) return;
        this.editItem.dhcp_enabled = this.editItem.dhcp_enabled ? 0 : 1;
    }

    public openAddSubnet() {
        this.isAddingSubnet = true;
        this.editItem = this.buildSubnetForm();
        this.showEditModal = true;
        this.service.render();
    }

    public async editSubnet(item: any) {
        const { code, data } = await wiz.call("get", { id: item.id });
        if (code === 200) {
            this.isAddingSubnet = false;
            this.editItem = this.buildSubnetForm(data);
            this.showEditModal = true;
        }
        await this.service.render();
    }

    public async saveSubnet() {
        if (!this.editItem || this.savingSubnet) return;

        this.savingSubnet = true;
        await this.service.render();

        try {
            const dnsArr = [];
            if (this.editItem.dns1) dnsArr.push(this.editItem.dns1.trim());
            if (this.editItem.dns2) dnsArr.push(this.editItem.dns2.trim());
            this.editItem.dns_servers = dnsArr.join(', ');

            // Convert PE id
            if (this.editItem.preinstallation_environment_id === '' || this.editItem.preinstallation_environment_id === 'null') {
                this.editItem.preinstallation_environment_id = null;
            }
            if (this.isOpaStaticOnly(this.editItem)) {
                this.editItem.dhcp_enabled = 0;
            }

            const saveData = { ...this.editItem };
            delete saveData.dns1;
            delete saveData.dns2;

            const payload: any = { data: JSON.stringify(saveData) };
            if (!this.isAddingSubnet) {
                payload.id = this.editItem.id;
            }
            const { code, data } = await wiz.call(this.isAddingSubnet ? "create" : "update", payload);
            if (code === 200) {
                if (data?.pxe_generated === false && !data?.pxe_skipped) {
                    alert(data?.pxe_message || data?.message || 'Failed to generate PXE bootloader');
                }
                if (data?.dhcp_applied === false) {
                    alert(data?.message || 'Failed to regenerate DHCP configuration');
                }
                await this.load(this.isAddingSubnet ? 1 : this.search.page);
                this.showEditModal = false;
                this.isAddingSubnet = false;
                this.editItem = null;
            } else {
                alert(data?.message || (this.isAddingSubnet ? 'Failed to add subnet' : 'Failed to save subnet'));
            }
        } finally {
            this.savingSubnet = false;
            await this.service.render();
        }
    }

    public cancelEdit() {
        if (this.savingSubnet) return;
        this.showEditModal = false;
        this.isAddingSubnet = false;
        this.editItem = null;
        this.service.render();
    }

    public async deleteSubnet(event: any, id: number) {
        event.stopPropagation();
        if (!confirm("Are you sure you want to delete this subnet?")) return;
        const { code, data } = await wiz.call("delete", { id });
        if (code === 200) {
            if (data?.dhcp_applied === false) {
                alert(data?.message || 'Failed to regenerate DHCP configuration');
            }
            await this.load();
        }
        await this.service.render();
    }

    public async setDefault(id: number) {
        const { code } = await wiz.call("set_default", { id, field: 'default_rootfs_deploy_deliverer' });
        if (code === 200) await this.load();
        await this.service.render();
    }

    public getPeName(peId: any): string {
        if (!peId) return '-';
        const pe = this.peList.find((p: any) => p.id === peId);
        return pe ? pe.name : `PE #${peId}`;
    }

    public totalPages() {
        return Math.ceil(this.total / this.search.dump) || 1;
    }

    public pageRange() {
        const tp = this.totalPages();
        const current = this.search.page;
        const delta = 2;
        let start = Math.max(1, current - delta);
        let end = Math.min(tp, current + delta);
        if (end - start < delta * 2) {
            if (start === 1) end = Math.min(tp, start + delta * 2);
            else start = Math.max(1, end - delta * 2);
        }
        const pages = [];
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    }

    // ===== Sorting =====
    public async sort(field: string) {
        if (this.sortField === field) {
            this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortField = field;
            this.sortDir = 'asc';
        }
        this.sortList();
        await this.service.render();
    }

    private sortList() {
        const field = this.sortField;
        const dir = this.sortDir === 'asc' ? 1 : -1;
        const numericFields = ['id', 'dhcp_enabled', 'default_lease', 'max_lease', 'vlan_id'];
        this.list.sort((a: any, b: any) => {
            let va = a[field];
            let vb = b[field];
            if (va == null) va = '';
            if (vb == null) vb = '';
            if (numericFields.includes(field)) return (Number(va) - Number(vb)) * dir;
            return String(va).localeCompare(String(vb)) * dir;
        });
    }

    public getSortIcon(field: string): string {
        if (this.sortField !== field) return 'bx-sort-alt-2';
        return this.sortDir === 'asc' ? 'bx-sort-up' : 'bx-sort-down';
    }
}

export default PageKieraSubnetsComponent;
